var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vux-loader/src/script-loader.js!../vue-loader/lib/selector?type=script&index=0!./slide.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-54531f20\"}!../vux-loader/src/template-loader.js!../vue-loader/lib/selector?type=template&index=0!./slide.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome-swiper/slide.vue
// module id = 565
// module chunks = 4